module.exports = __webpack_public_path__ + "static/img/serverQrcode.aa8cd11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serverQrcode.jpg
// module id = 5e09
// module chunks = 40